import { render, staticRenderFns } from "./AddLink.vue?vue&type=template&id=fc066a1c&scoped=true"
import script from "./AddLink.vue?vue&type=script&lang=js"
export * from "./AddLink.vue?vue&type=script&lang=js"
import style0 from "./AddLink.vue?vue&type=style&index=0&id=fc066a1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc066a1c",
  null
  
)

export default component.exports